import {range as loRange} from 'lodash'

/**
 * parseRange
 * Parse a range expression like "1,2,3,4-6" into the array [1,2,3,4,5,6]
 */
export function parseRange(range) {
    let results = []
    let parts = range.split(",")
    parts.forEach(function(part) {
        if (part.indexOf("-") != -1) {
            let lowerUpper = part.split("-")
            results = results.concat(
                loRange(parseInt(lowerUpper[0]), parseInt(lowerUpper[1])+1)
            )
        }
        else {
            results.push(parseInt(part))
        }
    })
    return results
}

/**
 * ordinal
 */
export function ordinal(n) {
    let s = ["th", "st", "nd", "rd"]
    let v = n % 100
    return n + (
        s[(v-20) % 10] || s[v] || s[0]
    )
 }